/**
 * PostHog configuration for Create React App.
 *
 * CRA only exposes env vars prefixed with REACT_APP_.
 * Map your PostHog project values to:
 *   REACT_APP_POSTHOG_KEY  → project API key (POSTHOG_KEY)
 *   REACT_APP_POSTHOG_HOST → ingestion host (POSTHOG_HOST)
 *
 * Host examples:
 *   https://us.i.posthog.com  (US Cloud)
 *   https://eu.i.posthog.com  (EU Cloud)
 *   https://your-domain.com   (self-hosted / reverse proxy)
 */

export const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
export const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

export const isPostHogEnabled = Boolean(POSTHOG_KEY);

/**
 * Shared init options used by the PostHog client.
 * @see https://posthog.com/docs/libraries/js/config
 */
export const posthogConfig = {
  api_host: POSTHOG_HOST,

  // Latest recommended defaults (SPA pageviews via history API, etc.)
  defaults: "2026-05-30",

  // We track SPA navigations explicitly via React Router (PostHogPageView).
  // Disable the automatic pageview so we do not double-count.
  capture_pageview: false,
  capture_pageleave: true,

  // Click / form / input autocapture
  autocapture: true,

  // Session recordings with sensitive input masking
  disable_session_recording: false,
  session_recording: {
    maskAllInputs: true,
    maskInputOptions: {
      password: true,
      email: true,
      tel: true,
    },
  },

  persistence: "localStorage+cookie",

  loaded: (posthog) => {
    if (process.env.NODE_ENV === "development") {
      posthog.debug();
    }
  },
};
